/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { mergeMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { MessageService } from 'primeng/api';
import { getCircularReplacer } from '@irian-ro/util-functions';

@Injectable({
  providedIn: 'root',
})
export class ErrorTranslationService {
  constructor(private readonly messageService: MessageService, private readonly translateService: TranslateService) {}

  translateAndShowParameterizedException(err: any) {
    const parameterTranslation$ = this.translateParameters(err.error.params);

    this.getExceptionTranslationObservableWithTranslatedParameters(parameterTranslation$, err).subscribe((res) => {
      this.messageService.add({
        key: 'global-error',
        severity: 'error',
        summary: res,
        life: 20000,
      });
    });
  }

  translateAndShowSimpleException(
    title: string | undefined,
    description: string | string[] | undefined,
    defaultTitle: string,
    defaultDescription: any
  ) {
    const titleTranslated = this.translateService.instant('error.' + title, {
      defaultValue: defaultTitle,
    });
    let descriptionTranslated:string | null = null

    if(Array.isArray(description)) {
      const arrayTranslations = description.map(des => this.translateService.instant('error.' + des, {defaultValue : ' '}))
          .filter((translate : string) => translate !== ' ')
          .join("\n")

      console.log(arrayTranslations)
      descriptionTranslated = arrayTranslations === '' ? defaultDescription : arrayTranslations;
    }
    else {
      descriptionTranslated = this.translateService.instant('error.' + description, {
        defaultValue: defaultDescription,
      });
    }

    this.messageService.add({
      key: 'global-error',
      severity: 'error',
      summary: titleTranslated,
      detail:
        typeof descriptionTranslated === 'string'
          ? descriptionTranslated
          : JSON.stringify(descriptionTranslated, getCircularReplacer()),
      life: 20000,
    });
  }

  private translateParameters(params: any): Observable<any> {
    const paramKeys = Object.keys(params);

    const paramTranslations: any = [];

    paramKeys.forEach((key) =>
      paramTranslations.push(
        this.translateService.get('http-error-interceptor.' + params[key], {
          defaultValue: params[key],
        })
      )
    );

    return of(paramTranslations);
  }

  private getExceptionTranslationObservableWithTranslatedParameters(
    parameterTranslation$: Observable<any>,
    err: any
  ): Observable<any> {
    return parameterTranslation$.pipe(
      mergeMap((translations) => {
        const interpolationParams = this.buildInterpolationParameters(translations);
        return this.translateService.get('http-error-interceptor.' + err.error.message, interpolationParams);
      })
    );
  }

  private buildInterpolationParameters(translations: Array<any>) {
    console.log('ddd');
    const interpolationParams = {};
    let index = 0;
    translations.forEach((translation) => {
      interpolationParams['param' + index] = translation;
      index++;
    });
    return interpolationParams;
  }
}
